<template>
    <div class="border-bottom px-3 py-2" v-if="message">
        <div class="d-flex align-items-center messenger-header position-relative">
            <b-avatar variant="primary" class="mr-2" size="40px" :src="message.message_participant.participant_photo_profile" :text="_gHlp.formatInitials(message.message_participant.participant_fullname)"></b-avatar>
            <b-row>
                <b-col cols="12" class="d-flex align-items-center name">
                    <p class="mb-0 font-weight-500 mr-1">{{ message.message_participant.participant_fullname }}</p>
                </b-col>
                <b-col cols="12" class="message">
                    <RichTextRenderer :content="message.message_content" />
                </b-col>
                <div class="position-absolute top-0" style="right: 8px">
                    <span class="text-muted">{{ message.message_created_date | dateFormatFromNow }}</span>
                </div>
            </b-row>
        </div>

        <!-- Replies -->
        <div class="d-flex align-items-center replies px-3" v-if="message.message_reply_items.length > 0">
            <b-avatar variant="primary" class="mr-2 invisible" style="width: 40px; height: 20px;" :src="message.message_participant.participant_photo_profile" :text="_gHlp.formatInitials(message.message_participant.participant_fullname)"></b-avatar>
            <b-row>
                <b-col cols="12" class="pl-0">
                    <div class="text-muted cursor-pointer" v-b-toggle="`collapse-${message.message_id}`">
                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="12" height="12" viewBox="0 0 512 512"><path fill="currentColor" d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>
                        <span class="text-xs">Replies</span>
                    </div>
                </b-col>
            </b-row>
        </div>

        <b-row no-gutters v-if="message.message_reply_items.length > 0">
            <b-col cols="11" offset="1" class="replies-messages">
                <b-collapse :id="`collapse-${message.message_id}`" class="my-2">
                    <div v-for="(reply, index) in message.message_reply_items" :key="index">
                        <div class="border-bottom py-2">
                            <div class="d-flex align-items-center position-relative">
                                <b-avatar variant="primary" class="mr-2" size="30px" :src="reply.message_participant.participant_photo_profile" :text="_gHlp.formatInitials(reply.message_participant.participant_fullname)"></b-avatar>
                                <b-row>
                                    <b-col cols="12" class="d-flex align-items-center name">
                                        <p class="mb-0 font-weight-500 text-xs mr-1">{{ reply.message_participant.participant_fullname }}</p>
                                    </b-col>
                                    <b-col cols="12" class="message">
                                        <RichTextRenderer :content="reply.message_content" />
                                    </b-col>
                                    <div class="position-absolute top-0 text-xs" style="right: 8px">
                                        <span class="text-muted">{{ reply.message_created_date | dateFormatFromNow }}</span>
                                    </div>
                                </b-row>    
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import RichTextRenderer from '@/views/Messaging/Chats/RichTextRenderer'
export default {
    props: {
        message: Object
    },
    components: {
        RichTextRenderer
    },
    methods: {
    }
}
</script>